import "./src/styles/tailwind.css"
require("typeface-open-sans")
